import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';

const PreallocationNode = ({ id, data }) => {
  const { identity, amount, onUpdate } = data;

  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className="bg-slate-800 rounded-xl border-2 border-emerald-500/50 shadow-xl min-w-[280px]"
    >
      {/* Header */}
      <div className="bg-gradient-to-r from-emerald-500 to-teal-600 rounded-t-lg px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center">
              <Gift className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-white text-sm">Preallocation</h3>
              <p className="text-white/70 text-xs">Initial token distribution</p>
            </div>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="p-4 space-y-3">
        <div>
          <label className="block text-xs font-medium text-slate-400 mb-1.5">
            Identity (VerusID)
          </label>
          <input
            type="text"
            value={identity || ''}
            onChange={(e) => onUpdate?.({ identity: e.target.value })}
            placeholder="e.g., MyIdentity@"
            className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-400 mb-1.5">
            Amount
          </label>
          <input
            type="number"
            value={amount || ''}
            onChange={(e) => onUpdate?.({ amount: parseFloat(e.target.value) || 0 })}
            placeholder="1000000"
            className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500"
          />
        </div>

        {identity && amount > 0 && (
          <div className="p-2 bg-emerald-500/10 rounded-lg border border-emerald-500/20">
            <p className="text-xs text-emerald-400 font-mono">
              {`{"${identity}": ${amount}}`}
            </p>
          </div>
        )}
      </div>

      {/* Handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="!w-3 !h-3 !bg-emerald-500 !border-2 !border-slate-800"
      />
    </motion.div>
  );
};

export default PreallocationNode;
